import { getSearchParams } from 'app/utility/helpers';
import {
  IScheduleSlot,
  TrainingTypeEnum,
  TrainingType
} from 'app/interfaces/schedule';

const ENDPOINTS = {
  [TrainingTypeEnum.INDIVIDUAL]: '/api/schedule-individual',
  [TrainingTypeEnum.GROUP]: '/api/schedule-group'
};

export async function getScheduleSlots({
  training_type,
  branch,
  specialist,
  start_date,
  end_date
}: {
  training_type: TrainingType;
  branch: string;
  specialist?: string | string[];
  start_date?: string;
  end_date?: string;
}) {
  try {
    if (!branch) {
      throw new Error('Branch is required');
    }

    if (
      !training_type ||
      !Object.values(TrainingTypeEnum).includes(training_type)
    ) {
      throw new Error('invalid training type');
    }

    const endpoint = ENDPOINTS[training_type];

    const res = await fetch(
      `${endpoint}/?${getSearchParams(null, [
        { name: 'branch', value: branch },
        { name: 'specialist', value: specialist },
        { name: 'start_date', value: start_date },
        { name: 'end_date', value: end_date }
      ])}`,
      {
        headers: {
          'Content-Type': 'application/json'
        },
        next: { revalidate: 0 }
      }
    );

    if (!res.ok) {
      throw new Error('fetch error');
    }

    const json = (await res.json()) as IScheduleSlot[] | { error: string };

    // Роут при сбое upstream отдаёт объект { error } — это ошибка.
    // Пустой массив — валидный результат «занятий нет», не ошибка.
    if (!Array.isArray(json)) {
      throw new Error('invalid data');
    }

    return json;
  } catch (error) {
    return [];
  }
}
